module.exports = __webpack_public_path__ + "d39835cd59c7d33c80db852a40ce52b8.jpg";